import config from './config'

import {newsAndInfoAxios} from './axios'

import http from '../../util/http'

export default http(newsAndInfoAxios,config.api)